import React, { Fragment, useContext, useEffect, useState } from "react";
import { faCalendarCheck, faUser } from "@fortawesome/free-regular-svg-icons";
import { faBan, faCheckCircle, faCircleXmark, faFileSignature, faMoneyBill, faSpinner, faTicket } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { BasicContext } from "../../App";
import { postMethod } from "../../requests";

const UserPayment = (props) => {
    const { t } = useTranslation();
    const { p, showActions, onShowCancelPaymentModal, checkPrivilege } = props;
    const { changeView } = useContext(BasicContext);
    const [loading, setLoading] = useState(true);
    const [privillege, setPrivillege] = useState(null);

    const checkPrivillege = async () => {
        const res = await postMethod("/check-transactions-view-privillege");
        setPrivillege(res.data.status);
    };

    useEffect(() => {
        if (privillege !== null) setLoading(false);
        // eslint-disable-next-line
    }, [privillege]);

    useEffect(() => {
        if (checkPrivilege) checkPrivillege();
        else setPrivillege(true);
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <tr>
                <td className="border-bottom-0 pb-0">
                    <FontAwesomeIcon icon={faFileSignature} className="me-1 me-lg-2" />
                    {p.order_number}
                </td>

                <td className={`border-bottom-0 pb-0`}>
                    <FontAwesomeIcon icon={faTicket} className="me-1 me-lg-2" />
                    {p.pass_name} ({p.up_price} {t("currency")})
                </td>
                {showActions && (
                    <td className="text-center" rowSpan={5}>
                        {p.up_paid === p.up_price ? (
                            <Button variant="outline-secondary" className="btn-table-action" onClick={() => onShowCancelPaymentModal(p)}>
                                <FontAwesomeIcon icon={faBan} />
                            </Button>
                        ) : null}
                    </td>
                )}
            </tr>
            <tr>
                <td className="border-bottom-0 pb-0">
                    <FontAwesomeIcon icon={faFileSignature} className="me-1 me-lg-2" />
                    {p.payment_type_name}
                </td>
                <td className={`border-bottom-0 pb-0`}>
                    {loading ? (
                        <>
                            {t("loadingData")} <FontAwesomeIcon icon={faSpinner} className="ms-2 rotate-center" />
                        </>
                    ) : (
                        <Fragment>
                            {privillege ? (
                                <>
                                    <FontAwesomeIcon icon={faUser} className="me-1 me-lg-2" />
                                    <Button
                                        variant="link"
                                        size="sm"
                                        className="p-0"
                                        onClick={() => changeView({ nav: "users", sub: "userDetails", params: { userID: p.user_id, tabName: "transactions" } })}
                                    >
                                        {p.user_name} {p.user_surname}
                                    </Button>
                                </>
                            ) : (
                                <>
                                    <FontAwesomeIcon icon={faCalendarCheck} className="me-1 me-lg-2" />
                                    {moment(p.create_date).format("YYYY-MM-DD HH:mm:ss")}
                                </>
                            )}
                        </Fragment>
                    )}
                </td>
            </tr>
            <tr>
                <td className="border-bottom-0 pb-0">
                    <FontAwesomeIcon icon={faMoneyBill} className="me-1 me-lg-2" />
                    {p.payment_amount.toFixed(2).toString().replace(".", ",")} {t("currency")}
                </td>
                <td className={`border-bottom-0 pb-0`}>
                    {p.payment_status_code === "PAID" ? (
                        <span className="text-success">
                            <FontAwesomeIcon icon={faCheckCircle} className="me-1 me-lg-2" />
                            {t(`payments.${p.payment_status_code}`)}
                        </span>
                    ) : (
                        <span className="text-danger">
                            <FontAwesomeIcon icon={faCircleXmark} className="me-1 me-lg-2" />
                            {t(`payments.${p.payment_status_code}`)}
                        </span>
                    )}
                </td>
            </tr>
            <tr>
                <td className="border-bottom-0 pb-0" colSpan={2}>
                    {t("payments.paymentComment")}: {p.payment_comment ? p.payment_comment : <span className="opacity-50">{t("lack")}</span>}
                </td>
            </tr>

            <tr>
                <td className="">
                    <FontAwesomeIcon icon={faCalendarCheck} className="me-1 me-lg-2" />
                    {moment(p.create_date).format("YYYY-MM-DD HH:mm:ss")}
                </td>
                <td className="">
                    {t("payments.registeredBy")}: {p.creator_name} {p.creator_surname}
                </td>
            </tr>
        </Fragment>
    );
};

export default UserPayment;
